import React, { FunctionComponent } from "react";
import styles from "./CardChallenge.module.scss";
import cn from "classnames";
import LevelIndicator from "../LevelIndicator/LevelIndicator";
import Tags from "../Tags/Tags";
import Button from "../Buttons/Button";
import { CheckCircleRounded } from "@material-ui/icons";
import { Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import CodeBlock from "../CodeBlock/CodeBlock";

interface CardChallenge {
  tags: string[];
  price: string;
  name: string;
  intro: string;
  level: number;
  id: string;
  thumbnailImage: string;
  isNew?: boolean;
}

const CardChallenge: FunctionComponent<{
  challenge: CardChallenge;
  to: string;
  completed?: boolean;
}> = ({
  challenge: { tags, isNew, name, intro, level, thumbnailImage },
  to,
  completed,
}) => {
  return (
    <Link className={styles.cardChallenge} to={to}>
      <div className={styles.cardChallenge_imgWrapper}>
        <img src={thumbnailImage} alt={name} loading="lazy" />
      </div>

      <div className={styles.cardChallenge_content}>
        <div className={styles.cardChallenge_content_top}>
          <Tags tags={tags} />

          {isNew && (
            <div
              className={cn(
                styles.cardChallenge_isNew,
                styles.cardChallenge_isNew__red
              )}
            >
              new
            </div>
          )}
        </div>

        <h4>{name}</h4>

        <div className={styles.cardChallenge_intro}>
          <ReactMarkdown
            renderers={{ code: CodeBlock }}
            source={intro}
          ></ReactMarkdown>
        </div>

        <LevelIndicator levelIndex={level} />

        <div className={styles.cardChallenge_buttonRow}>
          {!completed && (
            <Button
              disableElevation
              buttonVariant="default"
              textTransform="capitalize"
              aria-label="View challenge"
            >
              View Challenge
            </Button>
          )}

          {completed && (
            <Button
              textTransform="capitalize"
              disabled
              startIcon={
                <CheckCircleRounded
                  color="inherit"
                  style={{ color: "var(--green-dark)" }}
                />
              }
              aria-label="Completed"
            >
              Yay! Completed
            </Button>
          )}
        </div>
      </div>
    </Link>
  );
};

export default CardChallenge;
